import Text from '@components/Text';
import colors from '@constants/colors';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

/** 결제 화면 섹션 제목 */
function SectionTitle({ children }: Props) {
    return (
        <Text size='title' fontWeight='bold' color={colors.textPrimary}>
            {children}
        </Text>
    );
}

export default SectionTitle;
